import { Dialog } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { actions, RequestProgressState } from "src/requestProgress/reducer";
import { getRequestProgress } from "src/requestProgress/selector";
import { isRequesting, transitionIfFinished } from "../requestProgress/helpers";

import { onUploadFormChange } from "src/documentUpload/actions";
import { transformSingleEntityResult } from "src/documentUpload/helpers";
import { Entity, EntityDropdownOption } from "src/documentUpload/types";
import QuiqButton from "src/shared/QuiqButton";
import TextInput from "src/shared/TextInput";
import selectorsToProps from "src/utils/selectorsToProps";
import { createEntity, CreateEntityActionType } from "./actions";
import BackIcon from "./back-arrow.svg";
import countryOptions from "./countries";
import "./CreateEntityModal.scss";
import industryOptions from "./industries";
import { DropdownOption } from "./types";

interface CreateEntityModalProps {
  toggleModal: () => void;
  isOpen: boolean;
  isComingFromUploadScreen?: boolean;
  createEntity: CreateEntityActionType;
  requestProgress: RequestProgressState;
  onFinishedCallback?: (success: boolean) => void;
  onUploadFormChange: typeof onUploadFormChange;
}

interface CreateEntityModalState {
  name: string;
  country: string;
  city: string;
  industry: string;
  clientEntityID: string;
}
export class CreateEntityModal extends React.Component<
  CreateEntityModalProps,
  CreateEntityModalState
> {
  constructor(props: CreateEntityModalProps) {
    super(props);
    this.state = {
      name: "",
      country: "",
      city: "",
      industry: "",
      clientEntityID: ""
    };
  }

  public componentWillReceiveProps() {
    const isFinishedState = transitionIfFinished(actions.createEntity);
    if (isFinishedState && isFinishedState.finished) {
      this.resetState();
      if (this.props.onFinishedCallback) {
        this.props.onFinishedCallback(isFinishedState.success);
      }
    }
  }

  public render() {
    const dropdownStyles = {
      control: (provided: any) => ({
        ...provided,
        height: 60
      }),
      menuList: (provided: any) => {
        return {
          ...provided,
          maxHeight: 165
        };
      }
    };

    const { city, name, clientEntityID } = this.state;

    const isCreateBtnDisabled = Boolean(name.trim().length < 1);

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.toggleModal}
        PaperProps={{ className: "CreateEntityModal__paper" }}
        transitionDuration={0}
        className="CreateEntityModal"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        fullScreen={true}
        fullWidth={true}
      >
        {this.props.isComingFromUploadScreen && (
          <div
            className="CreateEntityModal__actions__back"
            onClick={this.props.toggleModal}
          >
            <img src={BackIcon} className="CreateEntityModal__back-icon" />
            Back to upload
          </div>
        )}
        <div className="CreateEntityModal__content">
          <form className="CreateEntityModal__form" onSubmit={this.onSubmit}>
            <h1 className="CreateEntityModal__header">Create New Entity</h1>
            <TextInput
              className="CreateEntityModal__input"
              placeholder="Name"
              required={true}
              onChange={this.handleNameChange}
              value={name}
            />

            <Select
              className="CreateEntityModal__input"
              options={industryOptions}
              placeholder="Industry"
              required={false}
              styles={dropdownStyles}
              onChange={this.handleIndustryChange as any}
            />

            <Select
              className="CreateEntityModal__input"
              options={countryOptions}
              placeholder="Country"
              required={false}
              styles={dropdownStyles}
              onChange={this.handleCountryChange as any}
            />

            <TextInput
              className="CreateEntityModal__input"
              placeholder="City"
              required={false}
              onChange={this.handleCityChange}
              value={city}
            />

            <TextInput
              className="CreateEntityModal__input"
              placeholder="Client Entity ID"
              required={false}
              onChange={this.handleClientEntityIdChange}
              value={clientEntityID}
            />

            <div className="CreateEntityModal__actions">
              <QuiqButton
                className="CreateEntityModal__actions__createEntity"
                type="submit"
                color="blue"
                isLoading={isRequesting(actions.createEntity)}
                isDisabled={isCreateBtnDisabled}
              >
                Create
              </QuiqButton>

              <QuiqButton
                className="CreateEntityModal__actions__cancel"
                variant="text"
                onClick={this.props.toggleModal}
                isDisabled={isRequesting(actions.createEntity)}
              >
                Cancel
              </QuiqButton>
            </div>
          </form>
        </div>
      </Dialog>
    );
  }

  private resetState = () => {
    this.setState({
      name: "",
      country: "",
      city: "",
      industry: "",
      clientEntityID: ""
    });
  };

  private onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { name, industry, city, country, clientEntityID } = this.state;

    if (name.length < 1) {
      return;
    }

    const entity: Entity = {
      name,
      city,
      country,
      industry,
      entityId: null,
      clientEntityID
    };
    this.props.createEntity(entity).then((newEntity: Entity) => {
      this.addEntityToUploadForm(newEntity);
    });
  };

  private addEntityToUploadForm = (entity: Entity) => {
    if (!this.props.isComingFromUploadScreen) {
      return;
    }

    const entityDropdownOption: EntityDropdownOption = transformSingleEntityResult(
      entity
    );

    this.props.onUploadFormChange({ entity: entityDropdownOption });
  };
  private handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ name: e.target.value });
  };
  private handleIndustryChange = (option: DropdownOption) => {
    this.setState({ industry: option.value });
  };
  private handleCountryChange = (option: DropdownOption) => {
    this.setState({ country: option.value });
  };
  private handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ city: e.target.value });
  };
  private handleClientEntityIdChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState({ clientEntityID: e.target.value });
  };
}

export default connect(
  selectorsToProps({
    requestProgress: getRequestProgress
  }),
  {
    createEntity: createEntity.action,
    onUploadFormChange
  }
)(CreateEntityModal);



// WEBPACK FOOTER //
// ./src/createEntityModal/CreateEntityModal.tsx